"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatedPropertyRule = void 0;
var rule_1 = require("./rule");
var property_1 = require("./property");
var observable_array_1 = require("./observable-array");
var rule_invocation_type_1 = require("./rule-invocation-type");
var calculationErrorDefault = null;
var CalculatedPropertyRule = /** @class */ (function (_super) {
    __extends(CalculatedPropertyRule, _super);
    function CalculatedPropertyRule(rootType, name, options) {
        var _this = this;
        var property;
        var defaultIfError = calculationErrorDefault;
        var calculateFn;
        if (!name) {
            name = options.name;
        }
        if (options) {
            if (options.property) {
                property = typeof options.property === "string" ? rootType.getProperty(options.property) : options.property;
                // indicate that the rule is responsible for returning the value of the calculated property
                options.returns = [property];
            }
            if (!name) {
                // Generate a reasonable default rule name if not specified
                name = options.name = (rootType.fullName + "." + (typeof property === "string" ? property : property.name) + ".Calculated");
            }
            if (options.hasOwnProperty("defaultIfError"))
                defaultIfError = options.defaultIfError;
            calculateFn = options.calculate;
        }
        // Call the base rule constructor
        _this = _super.call(this, rootType, name, options) || this;
        // Public read-only properties
        Object.defineProperty(_this, "property", { enumerable: true, value: property });
        // Public settable properties
        _this.defaultIfError = defaultIfError;
        _this.isDefaultValue = !!options.isDefaultValue;
        // Backing fields for properties
        if (calculateFn)
            Object.defineProperty(_this, "_calculateFn", { enumerable: false, value: calculateFn, writable: true });
        // register the rule with the target property
        _this.property.rules.push(_this);
        // mark the property as calculated if the rule runs on property access and is not a default value calculation
        if (!options.isDefaultValue && _this.invocationTypes & rule_invocation_type_1.RuleInvocationType.PropertyGet)
            _this.property.isCalculated = true;
        return _this;
    }
    CalculatedPropertyRule.prototype.register = function () {
        var _this = this;
        _super.prototype.register.call(this);
        if (this.isDefaultValue) {
            // Ensure that a default value rule will run if a calculation that it depends on is changed.
            // A property with a default value rule may have a persisted value, in which case it will
            // not run unless one of its predicates fires a change event. A calculation will not fire
            // a change event the first time it runs if it didn't previously have a value, which may
            // be the case for existing instances if the calculation is never accessed (ex: a hidden field).
            // So, in order to ensure that the default rule's calculated predicates fire a change event,
            // we must ensure that the calculation is accessed when the object is initialized.
            this.rootType.initExisting.subscribe(function (args) {
                // If the property is initialized (i.e. it has an initial persisted value),
                // run the calculation and throw away the result.
                var initialValue = args.entity.__fields__[_this.property.name];
                if (initialValue !== undefined) {
                    try {
                        _this.calculateFn.call(args.entity);
                    }
                    catch (e) {
                    }
                }
            });
        }
    };
    Object.defineProperty(CalculatedPropertyRule.prototype, "calculateFn", {
        get: function () {
            var calculateFn;
            // Convert string functions into compiled functions on first execution
            if (this._calculateFn.constructor === String) {
                // TODO: Calculation expression support
                var calculateExpr = this._calculateFn;
                var calculateCompiledFn = new Function("return " + calculateExpr + ";");
                calculateFn = this._calculateFn = calculateCompiledFn;
            }
            else {
                calculateFn = this._calculateFn;
            }
            return calculateFn;
        },
        enumerable: false,
        configurable: true
    });
    CalculatedPropertyRule.prototype.execute = function (obj) {
        if (this.isDefaultValue && this.model.$suppressDefaultRules) {
            return;
        }
        // Calculate the new property value
        var newValue;
        if (this.defaultIfError === undefined) {
            newValue = this.calculateFn.call(obj);
        }
        else {
            try {
                newValue = this.calculateFn.call(obj);
            }
            catch (e) {
                newValue = this.defaultIfError;
            }
        }
        // Exit immediately if the calculated result was undefined
        if (newValue === undefined) {
            return;
        }
        // modify list properties to match the calculated value instead of overwriting the property
        if (this.property.isList) {
            var newList_1 = newValue;
            // ensure the initial calculation of the list does not raise change events
            // defaulting a list property should raise change events
            if (!this.isDefaultValue && !this.property.isInited(obj))
                property_1.Property$init(this.property, obj, newList_1);
            else {
                // compare the new list to the old one to see if changes were made
                var curList = this.property.value(obj);
                if (newList_1.length === curList.length) {
                    var noChanges = true;
                    for (var i = 0; i < newList_1.length; ++i) {
                        if (newList_1[i] !== curList[i]) {
                            noChanges = false;
                            break;
                        }
                    }
                    if (noChanges) {
                        return;
                    }
                }
                // update the current list so observers will receive the change events
                // events will not be raised if this is the initial calculation of the list
                curList.batchUpdate(function (array) {
                    observable_array_1.updateArray(array, newList_1);
                });
            }
        }
        else {
            // Otherwise, just set the property to the new value
            this.property.value(obj, newValue, { calculated: true });
        }
    };
    CalculatedPropertyRule.prototype.toString = function () {
        return "calculation of " + this.property.name;
    };
    return CalculatedPropertyRule;
}(rule_1.Rule));
exports.CalculatedPropertyRule = CalculatedPropertyRule;
